/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Form/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import AppointmentReminders from './AppointmentReminders/index'
import Description from './Description/index'
import Number from './Number/index'
import React from 'react'
import SendNextAppointmentReminder from './SendNextAppointmentReminder/index'
import Type from './Type/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Form({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Phone/NewPhone/Content/Content/Form"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="Form.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Form.Vertical"
  data-view-path={viewPath}
 style={{'--pr-1-9F4O': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<Number
  viewPath={`${viewPath}/Number`}
/>
</div>
<div
  data-testid="Form.Vertical:1"
  data-view-path={viewPath}
 style={{'--pl-2-9F4O': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical1}`}
>
<Type
  viewPath={`${viewPath}/Type`}
/>
</div>
</div>
<Description
  viewPath={`${viewPath}/Description`}
/>
<AppointmentReminders
  viewPath={`${viewPath}/AppointmentReminders`}
/>
<SendNextAppointmentReminder
  viewPath={`${viewPath}/SendNextAppointmentReminder`}
/>
{children}
</React.Fragment>)
}